"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextMedia = exports.TEXT_MEDIA_IMAGE_POSITION = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _Modal = require("b2b-components/theme/components/Modal");
var _Video = require("b2b-components/theme/components/Video");
var _VideoPlay = require("b2b-components/theme/components/VideoPlay");
var _classnames = _interopRequireDefault(require("classnames"));
var _upperCaseFirst = require("upper-case-first");
require("./TextMedia.scss");
var TEXT_MEDIA_IMAGE_POSITION = /*#__PURE__*/function (TEXT_MEDIA_IMAGE_POSITION) {
  TEXT_MEDIA_IMAGE_POSITION["default"] = "default";
  TEXT_MEDIA_IMAGE_POSITION["left"] = "left";
  TEXT_MEDIA_IMAGE_POSITION["right"] = "right";
  return TEXT_MEDIA_IMAGE_POSITION;
}({});
exports.TEXT_MEDIA_IMAGE_POSITION = TEXT_MEDIA_IMAGE_POSITION;
var TextMedia = function TextMedia(_ref) {
  var className = _ref.className,
    htmlText = _ref.htmlText,
    imageCaption = _ref.imageCaption,
    imageUrl = _ref.imageUrl,
    isVideoModalOpened = _ref.isVideoModalOpened,
    onVideoModalClose = _ref.onVideoModalClose,
    onVideoPlayClick = _ref.onVideoPlayClick,
    videoThumbnailUrl = _ref.videoThumbnailUrl,
    videoUrl = _ref.videoUrl,
    _ref$imagePosition = _ref.imagePosition,
    imagePosition = _ref$imagePosition === void 0 ? TEXT_MEDIA_IMAGE_POSITION["default"] : _ref$imagePosition;
  if (!(htmlText || imageUrl || videoThumbnailUrl)) {
    return null;
  }
  var hasImagePosition = !!htmlText && imagePosition !== TEXT_MEDIA_IMAGE_POSITION["default"];
  var text = {
    ariaLabel: 'Video Preview',
    ariaCloseModal: 'Close Video Preview'
  };
  var rootClassName = (0, _classnames["default"])('cds-cms-TextMedia', (0, _defineProperty2["default"])({}, "cds-cms-TextMedia--ImagePosition".concat((0, _upperCaseFirst.upperCaseFirst)(imagePosition || '')), hasImagePosition), className);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: rootClassName
  }, htmlText && !hasImagePosition && /*#__PURE__*/_react["default"].createElement("span", {
    className: "cds-cms-RichTextEditor",
    dangerouslySetInnerHTML: {
      __html: htmlText
    }
  }), (imageUrl || videoThumbnailUrl) && /*#__PURE__*/_react["default"].createElement("figure", {
    className: "cds-cms-TextMedia-Figure"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-cms-TextMedia-FigureBody"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    alt: imageCaption || '',
    className: "cds-cms-TextMedia-FigureImage",
    src: imageUrl || videoThumbnailUrl
  }), videoUrl && /*#__PURE__*/_react["default"].createElement(_VideoPlay.VideoPlay, {
    onClick: onVideoPlayClick
  })), imageCaption && /*#__PURE__*/_react["default"].createElement("figcaption", {
    className: "cds-cms-TextMedia-FigureCaption"
  }, imageCaption)), htmlText && hasImagePosition && /*#__PURE__*/_react["default"].createElement("span", {
    className: "cds-cms-RichTextEditor",
    dangerouslySetInnerHTML: {
      __html: htmlText
    }
  })), videoUrl && /*#__PURE__*/_react["default"].createElement(_Modal.Modal, {
    animationType: _Modal.MODAL_ANIMATION_TYPE.fade,
    content: function content() {
      return /*#__PURE__*/_react["default"].createElement(_Video.Video, {
        videoUrl: videoUrl
      });
    },
    isOpen: isVideoModalOpened,
    onCloseModal: onVideoModalClose,
    text: {
      ariaLabel: text.ariaLabel,
      ariaCloseModal: text.ariaCloseModal
    },
    type: _Modal.MODAL_TYPE.fullscreen
  }));
};
exports.TextMedia = TextMedia;